// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3kqw_","label":"Section_label__N9YxE","contentWrap":"Section_contentWrap__2miHf","footer":"Section_footer__1Oqom","footerInner":"Section_footerInner__1R-uy"};